import { render, staticRenderFns } from "./OnsiteTemplatePreview.vue?vue&type=template&id=84984dde"
import script from "./OnsiteTemplatePreview.vue?vue&type=script&lang=js"
export * from "./OnsiteTemplatePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports